import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { TranslationModule } from '@galaxy/crm/static';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'crm-permission-required',
  templateUrl: './permission-required.component.html',
  styleUrls: ['./permission-required.component.scss'],
  imports: [MatButtonModule, GalaxyPageModule, GalaxyEmptyStateModule, MatIconModule, TranslationModule],
  standalone: true,
})
export class PermissionRequiredComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {}

  navigateToPreviousPage() {
    this.location.back();
  }

  navigateToHomePage() {
    this.router.navigate(['/']);
  }
}
